import { Typography, TransparentButton } from '@libs/components';
import { DISCLAIMER_HEIGHT } from 'src/constants';
import { HEADER_HEIGHT } from 'src/constants/elementDimensions';
import styled from 'styled-components';

type StickyContainerProps = {
  isUnderConstruction?: boolean;
  isAppDisclaimerVisible?: boolean;
};
export const StickyContainer = styled.div<StickyContainerProps>`
  position: sticky;
  z-index: ${({ theme }) => theme.zIndex.high};

  top: ${({ isUnderConstruction, isAppDisclaimerVisible }) => {
    if (isAppDisclaimerVisible && isUnderConstruction) {
      return `${HEADER_HEIGHT + DISCLAIMER_HEIGHT * 2}rem`;
    } else if (isUnderConstruction || isAppDisclaimerVisible) {
      return `${HEADER_HEIGHT + DISCLAIMER_HEIGHT}rem`;
    } else {
      return `${HEADER_HEIGHT}rem`;
    }
  }};
`;

export const HeaderNavigationWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  /* justify-content: space-between; */

  left: auto;
  right: auto;

  gap: 6.1rem;
  padding: 1.2rem 2.4rem 0 2.4rem;

  width: 100%;
  background-color: ${({ theme }) => theme.colors.surface.default};

  overflow-x: scroll;

  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const CustomTypography = styled(Typography)`
  white-space: nowrap;
  margin-bottom: 1.1rem;
`;

type ActiveNavigationLineProps = {
  isActive?: boolean;
};
export const ActiveNavigationLine = styled.div<ActiveNavigationLineProps>`
  display: ${({ isActive }) => (isActive ? 'block' : 'none')};

  height: 0.5rem;
  background-color: ${({ theme }) => theme.colors.interactive.brandColor};
  border-top-left-radius: ${({ theme }) => theme.borderRadius.x1};
  border-top-right-radius: ${({ theme }) => theme.borderRadius.x1};
`;

export const NavigationItemWrapper = styled(TransparentButton)`
  display: flex;
  cursor: pointer;
  flex-direction: column;
  justify-content: center;
`;
